import React, { useState } from 'react';
import { QuoteIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    school: "St Mary's College",
    quote: "St Mary's College students achieved 14% higher scores in maths tests after using Eedi in a mini-trial, demonstrating significant progress.",
    link: 'https://eedi.com/case-studies/st-marys-college-uk'
  }, {
    school: 'All Saints Catholic Academy',
    quote: "All Saints Catholic Academy, Mansfield, saw students surpass target grades and low-ability groups thrive, thanks to Eedi's tailored support and engaging content.",
    link: 'https://eedi.com/case-studies/all-saints-catholic-academy-uk'
  }, {
    school: 'Ecclesbourne School',
    quote: 'Ecclesbourne School, UK, achieved real results with Eedi, improving student performance and informing lesson planning through targeted interventions and retrieval practice.',
    link: 'https://eedi.com/case-studies/ecclesbourne-school-uk'
  }];
  const [activeIndex, setActiveIndex] = useState(0);
  const nextTestimonial = () => {
    setActiveIndex(prevIndex => (prevIndex + 1) % testimonials.length);
  };
  const prevTestimonial = () => {
    setActiveIndex(prevIndex => (prevIndex - 1 + testimonials.length) % testimonials.length);
  };
  return <section className="py-20 bg-gradient-to-br from-purple-100 to-blue-100 relative overflow-hidden" data-id="element-408">
      {/* Decorative elements */}
      <div className="absolute top-10 left-10 w-20 h-20 bg-white rounded-full opacity-20" data-id="element-409"></div>
      <div className="absolute bottom-10 right-10 w-32 h-32 bg-white rounded-full opacity-20" data-id="element-410"></div>
      <div className="container mx-auto px-4 relative z-10" data-id="element-411">
        <div className="text-center mb-16" data-id="element-412">
          <h2 className="text-3xl font-bold mb-4" data-id="element-413">
            Hear from Schools Using Eedi
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-purple-500 to-blue-500 mx-auto mb-6" data-id="element-414"></div>
          <p className="text-lg text-gray-700 max-w-2xl mx-auto" data-id="element-415">
            Discover the impact Eedi has had on other schools and how they've
            benefited from our partnership.
          </p>
        </div>
        {/* Desktop view - Grid */}
        <div className="hidden md:grid grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-416">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-all duration-300 transform hover:translate-y-[-4px] border border-gray-100 flex flex-col" data-id="element-417">
              <div className="p-6 flex-grow flex flex-col" data-id="element-418">
                <div className="relative" data-id="element-419">
                  <div className="absolute -top-2 -left-2 text-purple-200 opacity-30" data-id="element-420">
                    <QuoteIcon size={40} data-id="element-421" />
                  </div>
                  <div className="relative z-10" data-id="element-422">
                    <h3 className="font-bold text-xl mb-4 text-purple-700" data-id="element-423">
                      {testimonial.school}
                    </h3>
                    <p className="text-gray-700 mb-6 italic" data-id="element-424">
                      "{testimonial.quote}"
                    </p>
                  </div>
                </div>
                <div className="mt-auto" data-id="element-425">
                  <a href={testimonial.link} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-800 font-medium inline-flex items-center border-b border-blue-600 pb-1 transition-colors" data-id="element-426">
                    Read full case study
                  </a>
                </div>
              </div>
            </div>)}
        </div>
        {/* Mobile view - Carousel */}
        <div className="md:hidden" data-id="element-427">
          <div className="bg-white rounded-lg shadow-md overflow-hidden border border-gray-100 max-w-sm mx-auto" data-id="element-428">
            <div className="p-6" data-id="element-429">
              <div className="relative" data-id="element-430">
                <div className="absolute -top-2 -left-2 text-purple-200 opacity-30" data-id="element-431">
                  <QuoteIcon size={40} data-id="element-432" />
                </div>
                <div className="relative z-10" data-id="element-433">
                  <h3 className="font-bold text-xl mb-4 text-purple-700" data-id="element-434">
                    {testimonials[activeIndex].school}
                  </h3>
                  <p className="text-gray-700 mb-6 italic" data-id="element-435">
                    "{testimonials[activeIndex].quote}"
                  </p>
                  <a href={testimonials[activeIndex].link} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-800 font-medium inline-flex items-center border-b border-blue-600 pb-1 transition-colors" data-id="element-436">
                    Read full case study
                  </a>
                </div>
              </div>
            </div>
          </div>
          {/* Carousel controls */}
          <div className="flex justify-center items-center mt-6 space-x-4" data-id="element-437">
            <button onClick={prevTestimonial} className="p-2 rounded-full bg-white shadow-md text-purple-600 hover:bg-purple-50 transition-colors" aria-label="Previous testimonial" data-id="element-438">
              <ChevronLeftIcon size={20} data-id="element-439" />
            </button>
            {/* Dots */}
            <div className="flex space-x-2" data-id="element-440">
              {testimonials.map((_, index) => <button key={index} onClick={() => setActiveIndex(index)} className={`w-3 h-3 rounded-full transition-colors ${index === activeIndex ? 'bg-purple-600' : 'bg-purple-200'}`} aria-label={`Go to testimonial ${index + 1}`} data-id="element-441" />)}
            </div>
            <button onClick={nextTestimonial} className="p-2 rounded-full bg-white shadow-md text-purple-600 hover:bg-purple-50 transition-colors" aria-label="Next testimonial" data-id="element-442">
              <ChevronRightIcon size={20} data-id="element-443" />
            </button>
          </div>
        </div>
      </div>
    </section>;
}